class CookieConsent extends HTMLElement {
	constructor() {
		super();

		this.cookie = this;
		this.consentCookieName = 'cookie-consent';
		this.consentDays = 365;

		const stored = this.getCookie(this.consentCookieName);

		this.bindChoiceButtons();

		if (stored === 'accepted' || stored === 'closed' || stored === 'rejected') {
			this.applyStoredConsent(stored);
			this.hideBanner();
		} else {
			this.showBanner();
		}

		document.addEventListener('cashlab:open-cookie-settings', () => {
			this.openSettings();
		});
	}

	bindChoiceButtons() {
		const acceptBtn = this.querySelector('[data-accept-cookie]');
		const rejectBtn = this.querySelector('[data-reject-cookie]');

		if (acceptBtn && !acceptBtn.dataset.bound) {
			acceptBtn.dataset.bound = 'true';
			acceptBtn.addEventListener('click', (event) => this.setConsent(event, 'accepted'));
		}

		if (rejectBtn && !rejectBtn.dataset.bound) {
			rejectBtn.dataset.bound = 'true';
			rejectBtn.addEventListener('click', (event) => this.setConsent(event, 'rejected'));
		}
	}

	handleFullWidthLayout() {
		if (!this.cookie.classList.contains('full-width')) return;

		const applyPadding = () => {
			const cookieHeight = this.cookie.offsetHeight;
			if (cookieHeight > 0) {
				document.body.style.paddingBottom = cookieHeight + 'px';
			}
		};

		applyPadding();

		if (this._resizeBound) return;
		this._resizeBound = true;

		let width = window.innerWidth;
		window.addEventListener('resize', () => {
			if (window.innerWidth === width) return;
			width = window.innerWidth;
			if (this.cookie.style.display === 'block') {
				applyPadding();
			}
		});
	}

	setCookie(cname, cvalue, days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie =
			cname + '=' + cvalue + ';expires=' + date.toUTCString() + ';path=/;SameSite=Lax';
	}

	getCookie(cname) {
		const name = cname + '=';
		const ca = document.cookie.split(';');

		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}

		return '';
	}

	deleteCookie(name) {
		document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;SameSite=Lax';
	}

	showBanner() {
		this.cookie.style.display = 'block';
		this.handleFullWidthLayout();
	}

	hideBanner() {
		this.cookie.style.display = 'none';
		if (this.cookie.classList.contains('full-width')) {
			document.body.style.paddingBottom = '0px';
		}
	}

	openSettings() {
		this.showBanner();
		this.cookie.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
	}

	applyStoredConsent(stored) {
		const granted = stored === 'accepted' || stored === 'closed';
		this.updateConsentMode(granted);
		this.updateShopifyCustomerPrivacy(granted);
	}

	updateConsentMode(granted) {
		const state = granted ? 'granted' : 'denied';
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			window.dataLayer.push(arguments);
		}
		if (typeof window.gtag !== 'function') {
			window.gtag = gtag;
		}

		window.gtag('consent', 'update', {
			ad_storage: state,
			ad_user_data: state,
			ad_personalization: state,
			analytics_storage: state,
			personalization_storage: state
		});

		window.dataLayer.push({
			event: 'cashlab_consent_update',
			cashlab_consent: granted ? 'accepted' : 'rejected'
		});

		window.__cashlabConsent = {
			status: granted ? 'accepted' : 'rejected',
			analytics: granted,
			marketing: granted
		};

		document.dispatchEvent(
			new CustomEvent('cashlab:consent', {
				detail: window.__cashlabConsent
			})
		);
	}

	updateShopifyCustomerPrivacy(granted) {
		const apply = () => {
			if (!window.Shopify || !window.Shopify.customerPrivacy) return;
			try {
				window.Shopify.customerPrivacy.setTrackingConsent(
					{
						analytics: granted,
						marketing: granted,
						preferences: granted,
						sale_of_data: granted
					},
					() => {}
				);
			} catch (e) {
				/* Customer Privacy API unavailable */
			}
		};

		if (window.Shopify && window.Shopify.customerPrivacy) {
			apply();
			return;
		}

		if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
			window.Shopify.loadFeatures(
				[{ name: 'consent-tracking-api', version: '0.1' }],
				(error) => {
					if (!error) apply();
				}
			);
		}
	}

	setConsent(event, value) {
		event.preventDefault();

		const granted = value === 'accepted';
		this.setCookie(this.consentCookieName, value, this.consentDays);
		this.updateConsentMode(granted);
		this.updateShopifyCustomerPrivacy(granted);
		this.hideBanner();
	}
}

customElements.define('cookie-consent', CookieConsent);

document.addEventListener('click', (event) => {
	const trigger = event.target.closest('[data-cookie-settings]');
	if (!trigger) return;
	event.preventDefault();
	document.dispatchEvent(new CustomEvent('cashlab:open-cookie-settings'));
});
